var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z",
    fill: "#246BFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0809 14.1528C14.2909 12.2928 9.74094 12.2928 6.93094 14.1528C5.66094 15.0028 4.96094 16.1528 4.96094 17.3828C4.96094 18.6128 5.66094 19.7528 6.92094 20.5928C8.32094 21.5328 10.1609 22.0028 12.0009 22.0028C13.8409 22.0028 15.6809 21.5328 17.0809 20.5928C18.3409 19.7428 19.0409 18.6028 19.0409 17.3628C19.0309 16.1328 18.3409 14.9928 17.0809 14.1528Z",
    fill: "#246BFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFilled);
export default __webpack_public_path__ + "static/media/Person-filled.79fda9e9a407b758f67a8143578a541d.svg";
export { ForwardRef as ReactComponent };